// Cookie consent persistence (2.13.4). Stores the user's category selections in
// localStorage with a timestamp; no non-essential cookies are set before a
// choice exists. A small pub/sub lets Settings reopen the banner at any time.

export const COOKIE_CONSENT_KEY = 'tigerflow_cookie_consent'

export interface StoredCookieConsent {
  selections: Record<string, boolean>
  timestamp: string
}

type Listener = () => void
const listeners = new Set<Listener>()

export function getStoredConsent(): StoredCookieConsent | null {
  try {
    const raw = localStorage.getItem(COOKIE_CONSENT_KEY)
    return raw ? (JSON.parse(raw) as StoredCookieConsent) : null
  } catch {
    return null
  }
}

export function saveConsent(selections: Record<string, boolean>) {
  const payload: StoredCookieConsent = {
    selections,
    timestamp: new Date().toISOString(),
  }
  localStorage.setItem(COOKIE_CONSENT_KEY, JSON.stringify(payload))
  listeners.forEach(l => l())
}

export function clearConsent() {
  localStorage.removeItem(COOKIE_CONSENT_KEY)
  listeners.forEach(l => l())
}

// Imperative trigger to (re)open the cookie settings banner/modal from anywhere
// (e.g. the "Cookie Settings" tile in Settings).
let openRequested = false
export function requestOpenCookieSettings() {
  openRequested = true
  listeners.forEach(l => l())
}
export function consumeOpenRequest(): boolean {
  const was = openRequested
  openRequested = false
  return was
}

export function subscribeCookieConsent(listener: Listener): () => void {
  listeners.add(listener)
  return () => {
    listeners.delete(listener)
  }
}
